module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon10.7c91a28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon10.png
// module id = J8ur
// module chunks = 0